import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchOrder } from 'entities/Order';

import { SubmitHelpRequestParams } from '../types/submitHelpRequestSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

/**
 * Submits a help request for an order
 */
export const submitHelpRequestService = createAsyncThunk<
    void,
    SubmitHelpRequestParams,
    ThunkConfig<string>
>(
    'helpRequest/submitHelpRequestService',
    async ({ orderId, issueType, body }, thunkApi) => {
        const { extra, rejectWithValue, dispatch } = thunkApi;

        try {
            await extra.api.post(`/v1/orders/${orderId}/help`, {
                issueType,
                body,
            });

            // Refresh order data after successful submission
            await dispatch(fetchOrder({ id: orderId })).unwrap();
        } catch {
            return rejectWithValue('Failed to submit help request');
        }
    },
);
